// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"ae68554cf4245604","888":"5b27e9fccb496486"}[chunkId] + ".css";
};